import React, { useState, useMemo } from "react";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { FiltroLeggiDDL, FiltroDeputato, FiltroMembroGoverno, FiltroData } from "../filters";
import { DISEGNI } from "../../data/disegni_di_legge";
import { REACT_APP_SEARCH } from '../../config';
import axios from 'axios';

const INITIAL_STATE = {
    titolo: [],
    deputato: [],
    governo: { governo: null, membro: [] },
    data: { start: null, end: null },
    ricerca: "LA"
};

export default function FiltroDisegniDiLegge({ onResults, setLoading, setError, searched, onNuovaRicerca }) {
    const [filtri, setFiltri] = useState(INITIAL_STATE);

    const update = (campo) => (valore) =>
        setFiltri((prev) => ({ ...prev, [campo]: valore }));

    const handleSubmit = async () => {
        setLoading?.(true);
        setError?.('');

        try {
            const { data: risultati } = await axios.post(REACT_APP_SEARCH, filtri);
            onResults?.({ risultati, label: 'Leggi' });
        } catch (err) {
            console.error('Errore caricamento risultati Leggi', err);
            onResults?.({ risultati: [], label: 'Leggi' });
            setError?.(err.response?.data?.message || err.message || 'Errore nel caricamento dei risultati.');
        } finally {
            setLoading?.(false);
        }
    };

    return (
        <div>
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="Argomento">
                    <FiltroLeggiDDL documenti={DISEGNI} value={filtri.titolo} onChange={update('titolo')} />
                </AccordionTab>
                <AccordionTab header="Deputato">
                    <FiltroDeputato value={filtri.deputato} onChange={update('deputato')} />
                </AccordionTab>
                <AccordionTab header="Membro di Governo">
                    <FiltroMembroGoverno value={filtri.governo} onChange={update('governo')} />
                </AccordionTab>
                <AccordionTab header="Data">
                    <FiltroData value={filtri.data} onChange={update('data')} />
                </AccordionTab>
            </Accordion>

            <div className="mt-4 flex justify-content-center gap-2">
                <Button label="Avvia la ricerca" size="small" severity="success" onClick={handleSubmit} />
                {searched && (
                    <Button
                        label="Nuova ricerca"
                        severity="secondary"
                        size="small"
                        outlined
                        onClick={onNuovaRicerca}
                    />
                )}
            </div>
        </div>
    );
}
